export const STATUS_TO_PATH = {
  UNVERIFIED: '/createaccount',
  GST: '/gst',
  BANK_DETAILS: '/bank',
  TNC: '/terms',
  PAYMENT: '/pricing',
  MEMBERSHIP: '/pricing',
  UNDER_REVIEW: '/under_review',
  REJECTED: '/reject',
  ONBOARDING_COMPLETE: '/home',
};

/**
 * @param {string | undefined | null} status
 * @returns {string | undefined} the canonical onboarding path, or undefined if
 *   the status is unknown/unresolved (callers should then stay put).
 */
export function getOnboardingPathForStatus(status) {
  return status ? STATUS_TO_PATH[status] : undefined;
}
